__turbopack_context__.v({
  "active": "_4Dwh2q_active",
  "altContentsContainer": "_4Dwh2q_altContentsContainer",
  "arrowBox": "_4Dwh2q_arrowBox",
  "atcButton": "_4Dwh2q_atcButton",
  "buttonsFloat": "_4Dwh2q_buttonsFloat",
  "buttonsHolder": "_4Dwh2q_buttonsHolder",
  "c-choose": "_4Dwh2q_c-choose",
  "chooser": "_4Dwh2q_chooser",
  "float": "_4Dwh2q_float",
  "label": "_4Dwh2q_label",
  "logo-wrap": "_4Dwh2q_logo-wrap",
  "logoBox": "_4Dwh2q_logoBox",
  "normal": "_4Dwh2q_normal",
  "optionWrap": "_4Dwh2q_optionWrap",
  "plus-icon": "_4Dwh2q_plus-icon",
});
